import { css, styled, TextFieldProps } from '@mui/material';
import MUITextField from '@mui/material/TextField';
import { forwardRef } from 'react';
import { device } from 'src/constants/mediaQueries';

export const FormTextField = forwardRef<HTMLDivElement, TextFieldProps & { boldLabel?: boolean }>((props, ref) => {
  const { label, required, boldLabel, ...rest } = props;
  return (
    <TextFieldContainer>
      <Label bold={boldLabel}>{label}</Label>
      <TextField ref={ref} size="small" {...rest} required={required} />
    </TextFieldContainer>
  );
});

export const RequiredSpan = styled('span')`
  ${({ theme }) => css`
    font-size: ${theme.typography.body2.fontSize};
    font-weight: ${theme.typography.body2.fontWeight};
    @media only screen and ${device.mobileOrTablet} {
      font-size: 0.75rem;
    }
  `}
  opacity: 0.8;
`;

const TextField = styled(MUITextField)`
  width: 100%;
  text-align: left;

  & .MuiFilledInput-input {
    height: 48px;
    padding-top: 0;
    padding-bottom: 0;
    ${({ theme }) => css`
      -webkit-text-fill-color: ${theme.palette.text.primary};
      font-size: ${theme.typography.body1.fontSize};
      font-weight: ${theme.typography.body1.fontWeight};
      @media only screen and ${device.mobileOrTablet} {
        font-size: ${theme.typography.body2.fontSize};
      }
    `}
  }

  & .MuiFilledInput-root {
    background-color: ${({ theme }) => theme.palette.background.paper};
  }

  & .MuiInputBase-root.MuiFilledInput-root.Mui-disabled {
    background-color: ${({ theme }) => theme.palette.background.paper};
    color: red;
  }

  & .MuiInputBase-root.MuiFilledInput-root.Mui-disabled::before {
    border-bottom-style: solid;
  }

  & .MuiInputBase-input.MuiFilledInput-input.Mui-disabled {
    -webkit-text-fill-color: ${({ theme }) => theme.palette.text.primary};
  }

  & ::placeholder {
    font-style: italic;
  }
`;

const TextFieldContainer = styled('div')`
  max-width: 36rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: ${({ theme }) => theme.spacing(1.25)};
`;

const Label = styled('div', { shouldForwardProp: (prop: string) => prop !== 'bold' })<{ bold?: boolean }>`
  display: flex;
  justify-content: start;
  align-items: center;
  ${({ theme, bold }) => css`
    font-size: ${theme.typography.h6.fontSize};
    font-weight: ${bold ? theme.typography.fontWeightBold : /* istanbul ignore next */ theme.typography.h2.fontWeight};
    @media only screen and ${device.mobileOrTablet} {
      font-size: ${theme.typography.body1.fontSize};
    }
  `}
  gap: ${({ theme }) => theme.spacing(1)};
`;
